import React, { useContext } from "react"
import { FirebaseContext } from "../Firebase"
import { useLocation } from "@reach/router"
import { WingsLink } from "@wingspans-ui"

/**
 * A link that records when a user clicks it. Currently only records on employer
 * pages, but could be extended to other pages as well. Passes all props to an
 * underlying WingsLink component
 * @param {string} to - link destination
 * @param {string} linkSlug - unique id for link (ex: "twitter", "website"). if not provided, the *to* property will be recorded
 * @returns {JSX}
 */
const TrackedLink = ({ to, linkSlug, children, ...props }) => {
  const location = useLocation()
  const { firebase } = useContext(FirebaseContext)
  
  const pathSegments = location.pathname.split("/").filter(Boolean)
  const pageType = pathSegments[0]
  const pageSlug = pathSegments[1]
  const recordedLinkSlug = linkSlug || to

  const clickTrackerFunction = () => {
    if (firebase && recordedLinkSlug && pageType === "company") {
      firebase.logCompanyLinkClick(pageSlug, recordedLinkSlug)
    }
    return true
  }

  return (
    <WingsLink
      to={to}
      onClick={clickTrackerFunction}
      onContextMenu={clickTrackerFunction}
      {...props}
    >
      {children}
    </WingsLink>
  )
}

export default TrackedLink
